import $ from 'jquery'

$(document).on('turbolinks:load', (_e) =>
  $('[data-behaviour~="confirm-marketplace-archive"]').on('click', (e) => {
    const element = e.target
    const elementData = element.dataset
    const text = elementData.confirmationText
    const action = elementData.confirmationAction

    return window.sfConfirm({
      question: action,
      message: text,
      keep: true,
      confirmLabel: action,
      cancelLabel: I18n.t('js.global_confirmation_modal.default.cancel'),
      onConfirm: () => {
        element.parentNode.querySelector('.archive-link').click()
      },
    })
  })
)
